<template>
<div>
    <Breadcrumbs main="Project" title="Project Create" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <b-tabs content-class="mt-3" v-model="tabIndex">
                                <!-- Project Details -->
                                <b-tab title="Project Details" active>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label>Project Title <span style="color: red;">*</span></label>
                                                <input class="form-control" type="text" placeholder="Enter project title" v-model="project.title">
                                            </div>
                                        </div>
                                        <!-- <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Client <span><button class="btn-success ml-3">Add New</button></span></label>
                                                <select class="form-control digits" v-model="project.client">
                                                    <option v-for="(client, index) in clients" :key="index">{{ client }}</option>
                                                </select>
                                            </div>
                                        </div> -->
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>Project Type</label>
                                                <select class="form-control digits" v-model="projectCategory">
                                                    <option v-for="(type, index) in project_type" :key="index" :value="type">{{ type.title }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>Priority</label>
                                                <select class="form-control digits" v-model="project.priority">
                                                    <option v-for="(priority, index) in priorities" :key="index">{{ priority }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>Status</label>
                                                <select class="form-control digits" v-model="project.status">
                                                    <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label>Employee</label>
                                                <multiselect v-model="assignedEmployee" tag-placeholder="Add Emloyee" placeholder="Search employee" label="user_name" :max="formattedEmloyee.length" track-by="id" :options="formattedEmloyee" :multiple="true" :taggable="true"></multiselect>
                                            </div>
                                        </div>
                                        <!-- <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Client</label>
                                                <v-select class="custom-vue-select" :options="formattedClient" :reduce="client => client.id" label="company_name" v-model="project.client_ids" placeholder="Select a client"></v-select>
                                            </div>
                                        </div> -->
                                        <!-- <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Clients</label>
                                                <multiselect v-model="assignedClient" tag-placeholder="Add Client" placeholder="Search" label="company_name" :max="formattedClient.length" track-by="id" :options="formattedClient" :multiple="true" :taggable="true"></multiselect>
                                            </div>
                                        </div> -->
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Company <span style="color: red;">*</span></label>
                                                <select class="form-control digits" v-model="project.company" style="height:44px">
                                                    <option :value="null" :disabled="!project.company">-- Select Company --</option>
                                                    <option v-for="(company, index) in companies" :key="index" :value="company.id">{{ company.name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-sm-6" v-if="project.company">
                                            <div class="form-group">
                                                <label>Client</label>
                                                <v-select class="custom-vue-select" :options="formattedClient" :reduce="client => client.id" label="company_name" v-model="project.client_ids" placeholder="Select a client"></v-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Start Date <span style="color: red;">*</span></label>
                                                <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepicker" v-model="project.start_date"></datepicker>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Deadline</label>
                                                <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepickerend" :disabled-dates="endDateDisabled" v-model="project.deadline"></datepicker>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label>Upload project file</label>
                                                <b-form-file :multiple="true" placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label>Project Details</label>
                                                <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter project details..." rows="4" v-model="project.details"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <!-- Deliverables -->
                                <b-tab title="Deliverables">
                                    <div class="row mt-4">
                                        <div class="col-12">
                                       

                                            <div class=" mb-3" v-for="(deliverable, dIndex) in project.deliverables" :key="dIndex">
                                                <div class="">
                                            
                                                    <div class="row">
                                                        <div class="col-md-10">
                                                            <label>Delivery Type</label>
                                                            <input class="form-control" v-model="deliverable.delivery_type" placeholder="Milestone / Final Handover">
                                                        </div>


                                                        <div class="col-md-2 d-flex align-items-end">
                                                            <button class="btn btn-danger d-flex align-items-center" @click="removeDeliverable(dIndex)" v-if="project.deliverables.length > 1" v-b-tooltip.hover title="Delete deliverables">
                                                                <feather type="delete" size="20px" style="color: #ffffff; cursor: pointer;"></feather>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <hr>

                                                    <div class="row mb-2" v-for="(detail, detailIndex) in deliverable.details" :key="detailIndex">

                                                      
                                                        <div class="col-md-10">
                                                            <label>Expected Deliverables</label>
                                                            <input type="text" class="form-control" v-model="detail.expected_receivable">
                                                        </div>

                                                        <div class="col-md-2 d-flex align-items-end">
                                                             <button class="btn btn-danger d-flex align-items-center" @click="removeDetail(dIndex, detailIndex)" v-if="deliverable.details.length > 1" v-b-tooltip.hover title="Delete detail">
                                                                <feather type="delete" size="20px" style="color: #ffffff; cursor: pointer;"  ></feather>
                                                            </button>


                                                        </div>
                                                    </div>

                                                    <button class="btn btn-sm btn-outline-primary" @click="addDetail(dIndex)">
                                                        + Add
                                                    </button>

                                                </div>
                                            </div>

                                            <!-- <button class="btn btn-success" @click="addDeliverable">
                                                + Add Deliverable
                                            </button> -->

                                        </div>
                                    </div>
                                </b-tab>

                                <!-- Financial Info -->
                                <b-tab title="Financial Info">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>PO Value</label>
                                                <input class="form-control" type="number" placeholder="Enter PO Value" v-model="project.po_value">
                                                <small class="text-danger" v-if="errors.po_value">{{ errors.po_value }}</small>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Budget</label>
                                                <input class="form-control" type="number" placeholder="Enter project budget" v-model="project.budget">
                                                <small class="text-danger" v-if="errors.budget">{{ errors.budget }}</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>Vat Type</label>
                                                <select class="form-control digits" v-model="project.val_type">
                                                    <option v-for="(type, index) in val_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.val_type">{{ errors.val_type }}</small>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>PO Vat</label>
                                                <input class="form-control" type="number" placeholder="Enter PO Vat" v-model="project.po_vat">
                                                <small class="text-danger" v-if="errors.po_vat">{{ errors.po_vat }}</small>
                                            </div>
                                        </div>

                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>PO Vat Amount</label>
                                                <input class="form-control" type="number" placeholder="PO Vat Amount" v-model="vatAmount" disabled>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>AIT Type</label>
                                                <select class="form-control digits" v-model="project.ait_type">
                                                    <option v-for="(type, index) in val_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.ait_type">{{ errors.ait_type }}</small>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>PO AIT</label>
                                                <input class="form-control" type="number" placeholder="Enter PO AIT" v-model="project.po_ait">
                                                <small class="text-danger" v-if="errors.po_ait">{{ errors.po_ait }}</small>
                                            </div>
                                        </div>

                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label>PO AIT Amount</label>
                                                <input class="form-control" type="number" placeholder="PO AIT Amount" v-model="aitAmount" disabled>

                                            </div>
                                        </div>

                                    </div>

                                    <!-- Installments -->
                                    <div class="row mt-4" v-if="hasDeliverables">
                                        <div class="col-12">
                                            <button class="btn btn-outline-primary mb-3" @click="toggleInstallmentInput">
                                                Installments
                                            </button>

                                            <div class="row mb-3" v-if="showInstallmentInput">
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <label>How many installments?</label>
                                                        <input type="number" min="1" class="form-control" v-model.number="installmentCount">
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 d-flex align-items-end">
                                                    <div class="form-group mb-3">
                                                        <button class="btn btn-success" @click="generateInstallments">Generate</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card mb-3" v-for="(installment, iIndex) in project.installments" :key="iIndex">
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <p style="font-weight: 500;" class="mb-0">Installment #{{ iIndex + 1 }}</p>
                                                        <button class="btn btn-danger btn-sm d-flex align-items-center" @click="removeInstallment(iIndex)" v-b-tooltip.hover title="Delete installment">
                                                            <feather type="delete" size="18px" style="color: #ffffff; cursor: pointer;"></feather>
                                                        </button>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <label>Approximate Date</label>
                                                                <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="installment.date"></datepicker>
                                                            </div>
                                                        </div>
                                                          <div class="col-md-4">
                                                            <div class="form-group">
                                                                <label>Percentage</label>
                                                                <input class="form-control"   v-model.number="installment.text"
                                                                    @input="updateInstallmentAmount(installment)" placeholder="Enter percentage">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <label>Deliverables</label>
                                                                <multiselect v-model="installment.deliverables" placeholder="Select deliverable(s)" :options="deliverableOptions" :multiple="true"></multiselect>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <label>Expected Receivable Amount</label>
                                                                <input
                                                                class="form-control"
                                                                v-model="installment.amount"
                                                                readonly
                                                                >
                                                            </div>
                                                        </div>
                                                      
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- {{ subtotal }} -->
                                </b-tab>
                            </b-tabs>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateProjectCategory" class="btn btn-success mr-3">Create</button>
                                        <router-link to="/project/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import moment from "moment";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    mapState
} from 'vuex';
import Multiselect from 'vue-multiselect';
import {
    computed
} from "vue";
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            project: {
                title: '',
                details: null,
                category: '',
                start_date: null,
                deadline: null,
                priority: 'HIGH',
                status: 'PENDING',
                project_attachment: null,
                po_value: null,
                po_vat: null,
                po_ait: null,
                budget: null,
                val_type: 'inclusive',
                client_ids: '',
                ait_type: 'inclusive',
                company: '',
                deliverables: [{
                    delivery_type: '',
                    details: [{
                        expected_receivable: ''
                    }]
                }],
                installments: []
            },
            isButtonDisabled: false,
            tabIndex: 0,
            showInstallmentInput: false,
            installmentCount: null,
            calculatedDate: null,
            assignedEmployee: [],
            assignedClient: [],
            employee_ids: [],
            // client_ids: [],
            projectCategory: null,
            // project_type: [{
            //         id: 1,
            //         title: 'project',
            //     },
            //     {
            //         id: 2,
            //         title: 'others'
            //     }
            // ],

            priorities: ['HIGH', 'MEDIUM', 'LOW'],
            statuses: ['PENDING', 'APPROVED', 'WORKING', 'COMPLETED', 'ARCHIVED', 'PAUSED', 'POSTPONED', 'ARCHIVED'],
            val_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                po_value: '',
                po_vat: '',
                po_ait: '',
                budget: '',
                val_type: '',
                ait_type: ''
            },

            subtotal: computed(() => {

                const total = Number(this.project.po_value);
                const discount = Number(this.project.discount || 0);

                // Case 1: both VAT and TAX are inclusive → just apply discount to total
                if (this.project.val_type === 'inclusive' && this.project.ait_type === 'inclusive') {
                    const discounted = total - (total * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }

                // Case 2: Exclusive taxes → add them first
                let calculated = total;

                if (this.project.val_type === 'exclusive') {
                    calculated += this.vatAmount;
                }

                if (this.project.ait_type === 'exclusive') {
                    calculated += this.aitAmount;
                }

                // Apply discount to final calculated total
                const discounted = calculated - (calculated * discount / 100);
                return Math.round((discounted + Number.EPSILON) * 100) / 100;
            }),

            aitAmount: computed(() => {
                if (this.project ?.po_ait && this.project ?.ait_type && this.project ?.po_value) {
                    const po_vat = Number(this.project.po_ait);
                    return Math.round((this.basePrice * po_vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.project ?.po_vat && this.project ?.val_type && this.project ?.po_value) {
                    const po_vat = Number(this.project.po_vat);
                    return Math.round((this.basePrice * po_vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            basePrice: computed(() => {
                if (!this.project ?.po_value || !this.project ?.val_type || !this.project ?.ait_type) return 0;

                const total = Number(this.project.po_value);
                const po_vat = Number(this.project.po_vat || 0);
                const po_ait = Number(this.project.po_ait || 0);

                if (this.project.val_type === 'inclusive' && this.project.ait_type === 'inclusive') {
                    const divisor = 1 + (po_vat + po_ait) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.project.val_type === 'inclusive') {
                    divisor += po_vat / 100;
                }
                if (this.project.ait_type === 'inclusive') {
                    divisor += po_ait / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

        };
    },

    mounted() {
        this.$store.dispatch("projectType/fetchProjectType");
        this.$store.dispatch("employee/fetchEmployeeList");
        // this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("client/fetchCompany")
    },

    computed: {
        ...mapState({
            project_type: state => state.projectType.projectType,
            user_list: state => state.employee.employee_list,
            clients: state => state.client.client_by_company,
            companies: state => state.client.company

        }),

        endDateDisabled() {
            return {
                to: this.project.start_date ? new Date(this.project.start_date) : null
            };
        },

        formattedEmloyee() {
            return [
                ...this.user_list.map(user => ({
                    id: user.id,
                    user_name: user.user_name
                }))
            ];
        },

        formattedClient() {
            if (this.clients && this.clients.length > 0) {
                return [
                    ...this.clients ?.map(client => ({
                        id: client ?.user ?.id,
                        company_name: client ?.company_name
                    }))
                ];
            }
        },

        hasDeliverables() {
            return this.project.deliverables.some(deliverable => deliverable.delivery_type && deliverable.delivery_type.trim() !== '');
        },

        deliverableOptions() {
            return this.project.deliverables
                .flatMap(deliverable => deliverable.details || [])
                .map(detail => detail.expected_receivable)
                .filter(expected_receivable => expected_receivable && expected_receivable.trim() !== '');
        },
    },

    watch: {
        'project.start_date': function (newStartDate, oldStartDate) {
            if (this.project.deadline) {
                this.project.deadline = null
            }
        },

        'project.company'(newVal, oldVal) {
            this.$store.dispatch("client/fetchClient_ByCompany", newVal)
            this.project.client_ids = ''
        },
        'project.po_value'() {
    this.project.installments.forEach(installment => {
      this.updateInstallmentAmount(installment)
    })
  }
    },

    methods: {
         updateInstallmentAmount(installment) {
    const poValue = Number(this.project.po_value) || 0
    const percentage = Number(installment.text) || 0

    installment.amount = (poValue * percentage) / 100
  },
        uploadFile(e) {
            this.project.project_attachment = e.target.files[0]
        },

        validateProjectCategory() {
            this.errors = {
                po_value: '',
                po_vat: '',
                po_ait: '',
                budget: '',
                val_type: '',
            };

            let valid = true;

            if (this.projectCategory ?.title === 'PROJECT') {
                if (!this.project.po_value) {
                    this.errors.po_value = 'PO Value is required.';
                    valid = false;
                }
                if (!this.project.po_vat) {
                    this.errors.po_vat = 'PO VAT is required.';
                    valid = false;
                }
                if (!this.project.po_ait) {
                    this.errors.po_ait = 'PO AIT is required.';
                    valid = false;
                }
                if (!this.project.budget) {
                    this.errors.budget = 'Budget is required.';
                    valid = false;
                }
                if (!this.project.val_type) {
                    this.errors.val_type = 'Vat type is required.';
                    valid = false;
                }
                if (!this.project.ait_type) {
                    this.errors.ait_type = 'AIT type is required.';
                    valid = false;
                }
            }

            if (valid) {
                this.onSubmit();
            } else if (this.projectCategory ?.title === 'PROJECT') {
                this.tabIndex = 2;
            }
        },
        addDeliverable() {
            this.project.deliverables.push({
                delivery_type: '',
                date: '',
                details: [{
                    // quantity: '',
                    expected_receivable: ''
                }]
            })
        },

        removeDeliverable(index) {
            this.project.deliverables.splice(index, 1)
        },

        addDetail(deliverableIndex) {
            this.project.deliverables[deliverableIndex].details.push({
                // quantity: '',
                expected_receivable: ''
            })
        },

        removeDetail(deliverableIndex, detailIndex) {
            this.project.deliverables[deliverableIndex].details.splice(detailIndex, 1)
        },

        toggleInstallmentInput() {
            this.showInstallmentInput = !this.showInstallmentInput
        },

        generateInstallments() {
            if (!this.installmentCount || this.installmentCount < 1) return;

            for (let i = 0; i < this.installmentCount; i++) {
                this.project.installments.push({
                    date: '',
                    text: '',
                    amount: 0,
                    deliverables: []
                })
            }

            this.installmentCount = null
        },

        removeInstallment(index) {
            this.project.installments.splice(index, 1)
        },

        onSubmit() {
            // console.log('here')
            if (this.project.start_date !== null) {
                this.project.start_date = moment(String(this.project.start_date)).format("YYYY-MM-DD");
            }
            if (this.project.deadline !== null) {
                this.project.deadline = moment(String(this.project.deadline)).format("YYYY-MM-DD");
            }

            // this.project.title = this.project.title.trim() ? this.project.title : null;
            this.project.category = this.projectCategory ?.id;
            this.assignedEmployee.map(item => this.employee_ids.push(item.id));
            // this.assignedClient.map(item => this.client_ids.push(item.id));

            if (this.project.title && this.project.start_date && this.project.company) {
                this.$store.dispatch("project/addProject", {
                    project: this.project,
                    //  client:this.client_ids, 
                    employee: this.employee_ids
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.project.title = null,
                        this.project.details = null,
                        this.project.start_date = null,
                        this.project.deadline = null,
                        this.project.priority = 'HIGH',
                        this.project.status = 'APPROVED',
                        this.project.project_attachment = null
                        this.project.po_value = null
                        this.project.client_ids = null
                        this.project.po_vat = null
                        this.project.po_ait = null
                        this.project.budget = null
                        this.project.val_type = null
                        this.project.ait_type = null
                        this.assignedEmployee = []
                        this.assignedClient = []
                        this.client_ids = []
                        this.employee_ids = []
                        this.project. deliverables = [{
                    delivery_type: '',
                    details: [{
                        expected_receivable: ''
                    }]
                }]
                        this.project.installments = []
                        this.showInstallmentInput = false
                        this.installmentCount = null

                        setTimeout(() => {
                            this.$router.push(`/project/list`)
                        }, 2000)
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                this.project.title = '',
                    this.project.start_date = null,
                    this.project.company = null,
                    Swal.fire({
                        title: "Error!",
                        text: 'You must enter Project Title, Start Date & Company',
                        icon: "error"
                    });
            }
        }
    }
};
</script>
